import React, { createContext, PropsWithChildren, useState } from 'react';

import { SearchFormFieldEnum } from '../common/searchFormField.types';
import { CriteriaOperatorEnum } from '../common/types';
import { FetchUsersResponseType, useSearchCandidates } from '../features/candidates/useSearchCandidates';

export type CandidateDuplicatesContextType = {
  isCandidateDuplicated: boolean;
  duplicates: FetchUsersResponseType | undefined;
  setDuplicatesSearchData: ({ firstName, lastName }: { firstName: string; lastName: string }) => void;
};

const getSearchDuplicatesQuery = (firstName: string, lastName: string) => ({
  criteria: [
    {
      field: SearchFormFieldEnum.FirstName,
      value: firstName ?? '',
      operator: CriteriaOperatorEnum.EQ,
    },
    {
      field: SearchFormFieldEnum.LastName,
      value: lastName ?? '',
      operator: CriteriaOperatorEnum.EQ,
    },
  ],
  sort: [],
  from: 0,
  max: 10000,
});

const defaultCandidateDuplicatesContext: CandidateDuplicatesContextType = {
  isCandidateDuplicated: false,
  duplicates: undefined,
  setDuplicatesSearchData: () => undefined,
};

export const CandidateDuplicatesContext = createContext<CandidateDuplicatesContextType>(defaultCandidateDuplicatesContext);

export const CandidateDuplicatesProvider: React.FC<PropsWithChildren> = ({ children }) => {
  const [duplicatesSearchData, setDuplicatesSearchData] = useState({ firstName: '', lastName: '' });

  const { data: duplicates } = useSearchCandidates(
    getSearchDuplicatesQuery(duplicatesSearchData.firstName, duplicatesSearchData.lastName)
  );

  const isCandidateDuplicated = !!duplicates?.count;

  return (
    <CandidateDuplicatesContext.Provider value={{ isCandidateDuplicated, duplicates, setDuplicatesSearchData }}>
      {children}
    </CandidateDuplicatesContext.Provider>
  );
};
